import {createContext} from 'react'

export const WizardDataContext = createContext(null)